import Loading from "vue-loading-overlay";
export default {
    name: "SiteCart",
    components: {
        Loading
    },
    data() {
        return {
            isLoading: false,
            fullPage: true,
            loader: "bars",
            cartAddURL: 'add-cart',
            cartMinusURL: 'minus-cart',
            cartRemoveRowURL: 'remove-row-cart',
            clearCartURL: 'clear-cart',
            deviceImagePath: this.$api+"assets/sell/device/category-device/",
            cartItem: [],
            cartPurchaseItem: {},
            auth: [],
            myCart: 0,
            total_quantity: 0,
            total_price: 0.00,
            hideCart: false,
            hideEmptyCart: true,
            checkAuth: false,
            deviceCategory: localStorage.getItem('ChooseSoldDeviceCategory'),
            deviceInfo: localStorage.getItem('ChooseDevice'),
            deviceImage: localStorage.getItem('deviceImage') === null ? '' : localStorage.getItem('deviceImage'),
            deviceCondition: localStorage.getItem('ChooseDeviceCondition'),
            deviceCarrier: localStorage.getItem('ChooseDeviceCarrier'),
            deviceStorage: localStorage.getItem('ChooseDeviceStroage'),
            deviceOperation: localStorage.getItem('ChooseDeviceOperation'),
            cartJsonString: localStorage.getItem('cart'),
            cartPurchaseJsonString: localStorage.getItem('purchase_cart'),
            viewMobile: false,
        }
    },
    created() {
        this.loadCart();
        this.isMobile();

        console.log('this.viewMobile = ', this.viewMobile);
        //console.log(this.cartJsonString);
        //this.checkAuthentication();
    },
    methods: {
        isMobile: function() {
            console.log('Screen Width = ', screen.width);
            if( screen.width <= 760 ) {
                this.viewMobile=true;
            }
            else {
                this.viewMobile=false;
            }
        },
        loadCart: function() {
            let sell_total_price=0;
            let sell_total_quantity=0;
            let purchase_total_price=0;
            let purchase_total_quantity=0;
            let cart = JSON.parse(this.cartJsonString);
            let purchaseCart = JSON.parse(this.cartPurchaseJsonString);
            console.log(cart);
            this.cartItem=[];
            this.cartPurchaseItem.items=[];
            if(cart != null)
            {
                cart.items.forEach((row,index) => {
                    console.log(index, row);
                    row.pro_type="Sell";
                    row.image_path=this.$api+"assets/sell/device/category-device/"+row.deviceImage;
                    this.cartItem.push(row);
                });
    
                // this.total_price=cart.total_price;
                // this.total_quantity=cart.total_quantity;
                sell_total_price=cart.total_price;
                sell_total_quantity=cart.total_quantity;
                console.log('this.total_quantity = ',sell_total_quantity);
                this.$emit('updateMySellCart', sell_total_quantity);
            }
            

            
            console.log('purchase item ',purchaseCart);
            // console.log('purchase item ',purchaseCart.items.length);
            // console.log('purchase item type',typeof(purchaseCart.items));
            //this.cartItem=[];
            if(purchaseCart != null)
            {
                purchaseCart.items.forEach((row,index) => {
                    console.log(index);
                    row.pro_type="Purchase";
                    row.image_path=this.$api+"assets/buy/device/info/"+row.deviceImage;
                    this.cartPurchaseItem.items.push(row);
                    console.log('Purchase Row = ', row);
                });
                
                this.cartPurchaseItem.total_price=purchaseCart.total_price;
                this.cartPurchaseItem.total_quantity=purchaseCart.total_quantity;
                console.log('this.total_quantity = ',this.cartPurchaseItem.total_quantity);
                this.$emit('updatePurchaseCartBox', this.cartPurchaseItem.total_quantity);
            }

            this.total_price=(sell_total_price-0)+(purchase_total_price-0);
            this.total_quantity=(sell_total_quantity-0)+(purchase_total_quantity-0);

            
            
            
            
        },
        checkAuthentication: function() {
            this.isLoading = true;
            this.$axios.get(this.$api + 'api/check-authentication').then(response => {
                let data = response.data;
                this.auth = data;
                if(data.status == 200) {
                    this.checkAuth = true;
                }
                this.isLoading = false;
            }).catch(error => {
                console.log(error);
                this.isLoading = false;
            })
        },
        cartAdd: function(itemIndex) {
            console.log(itemIndex);
            let cart = JSON.parse(this.cartJsonString);
            let purchaseCart = JSON.parse(this.cartPurchaseJsonString);
            if(cart !=null)
            {
                console.log('Add = ',cart);
                cart.items.forEach((row,index) => {
                    if(row.cart_id==itemIndex){
                        cart.total_price+=row.unit_price;
                        cart.total_quantity++;
                        cart.items[index].qty++;
                        cart.items[index].price+=row.unit_price;
                    }
                });
                console.log('cart updated = ', cart);
                let sellDeviceCartString=JSON.stringify(cart);
                this.cartJsonString=sellDeviceCartString;
                localStorage.setItem('cart',sellDeviceCartString);
            }

            if(purchaseCart !=null)
            {
                console.log('Add = ',purchaseCart);
                purchaseCart.items.forEach((row,index) => {
                    if(row.cart_id==itemIndex){
                        purchaseCart.total_price+=parseFloat(row.unit_price);
                        purchaseCart.total_quantity++;
                        purchaseCart.items[index].qty++;
                        purchaseCart.items[index].price+=parseFloat(row.unit_price);
                    }
                });
                console.log('cart updated = ', purchaseCart);
                let purchaseDeviceCartString=JSON.stringify(purchaseCart);
                this.cartPurchaseJsonString=purchaseDeviceCartString;
                localStorage.setItem('purchase_cart',purchaseDeviceCartString);
            }
            
            this.loadCart();
        },
        cartMinus: function(itemIndex) {
            console.log(itemIndex);
            let cart = JSON.parse(this.cartJsonString);
            let purchaseCart = JSON.parse(this.cartPurchaseJsonString);

            if(cart!=null)
            {
                console.log('Deduct = ',cart);
                cart.items.forEach((row,index) => {
                    if(row.cart_id==itemIndex){
                        cart.total_price-=row.unit_price;
                        cart.total_quantity--;
                        cart.items[index].qty--;
                        cart.items[index].price-=row.unit_price;
                    }
                });
                console.log('cart updated = ', cart);
                let sellDeviceCartString=JSON.stringify(cart);
                this.cartJsonString=sellDeviceCartString;
                localStorage.setItem('cart',sellDeviceCartString);
            }

            if(purchaseCart !=null)
            {
                console.log('minus = ',purchaseCart);
                purchaseCart.items.forEach((row,index) => {
                    if(row.cart_id==itemIndex){
                        purchaseCart.total_price-=row.unit_price;
                        purchaseCart.total_quantity--;
                        purchaseCart.items[index].qty--;
                        purchaseCart.items[index].price-=row.unit_price;
                    }
                });
                console.log('cart updated = ', purchaseCart);
                let purchaseDeviceCartString=JSON.stringify(purchaseCart);
                this.cartPurchaseJsonString=purchaseDeviceCartString;
                localStorage.setItem('purchase_cart',purchaseDeviceCartString);
            }
            
            this.loadCart();
        },
        cartRemoveRow: function(itemID) {
            console.log(itemID);
            let cart = JSON.parse(this.cartJsonString);
            let purchaseCart = JSON.parse(this.cartPurchaseJsonString);
            if(cart!=null)
            {
                console.log('remove rows = ',cart);
                cart.items.forEach((row,index) => {
                    if(row.cart_id==itemID){
                        cart.total_price-=row.price;
                        cart.total_quantity-=row.qty;
                        cart.items.slice(index,1);
                        cart.items.splice(cart.items.indexOf(index), 1);
                    }
                });
                console.log('cart delete updated = ', cart);
                let sellDeviceCartString=JSON.stringify(cart);
                this.cartJsonString=sellDeviceCartString;
                localStorage.setItem('cart',sellDeviceCartString);
            }
            
            if(purchaseCart!=null)
            {
                console.log('remove rows = ',purchaseCart);
                purchaseCart.items.forEach((row,index) => {
                    if(row.cart_id==itemID){
                        console.log('Removing = ', row);
                        purchaseCart.total_price-=row.price;
                        purchaseCart.total_quantity-=row.qty;
                        purchaseCart.items.slice(index,1);
                        purchaseCart.items.splice(purchaseCart.items.indexOf(index), 1);
                    }
                });
                console.log('cart delete updated = ', purchaseCart);
                let purchaseDeviceCartString=JSON.stringify(purchaseCart);
                this.cartPurchaseJsonString=purchaseDeviceCartString;
                localStorage.setItem('purchase_cart',purchaseDeviceCartString);
            }
            
            

            this.loadCart();
        },
        cartClear: function() {
            let cart = JSON.parse(this.cartJsonString);
            if(cart!=null)
            {
                console.log('remove rows = ',cart);
                cart.total_price=0;
                cart.total_quantity=0;
                cart.items=[];
            }
            

            let purchasecart = JSON.parse(this.cartPurchaseJsonString);
            if(purchasecart!=null)
            {
                console.log('remove rows = ',cart);
                purchasecart.total_price=0;
                purchasecart.total_quantity=0;
                purchasecart.items=[];
            }
            
            let sellDeviceCartString=JSON.stringify(cart);
            let purchaseDeviceCartString=JSON.stringify(purchasecart);
            this.cartJsonString=sellDeviceCartString;
            this.cartPurchaseJsonString=purchaseDeviceCartString;
            localStorage.setItem('cart',sellDeviceCartString);
            localStorage.setItem('purchase_cart',purchaseDeviceCartString);
            this.loadCart();
        },
        checkOutAuth: function() {

            let totalQuantity = this.total_quantity+this.cartPurchaseItem.total_quantity;
            console.log('totalQuantity =  ', totalQuantity);

            if(totalQuantity==0)
            {
                alert("Please add new item in shopping cart to go checkout.");
                return false;
            }

            if(this.auth.status == 0)
            {
                this.$router.push({
                    name: 'checkoutAuthentication'
                });
            }
            else
            {
                this.$router.push({
                    name: 'Payment'
                });
            }
        },
    }
}